export const environment = {
    api_url: process.env.REACT_APP_API_URL,
    api_key: process.env.REACT_APP_API_KEY ?? '',
    /// Telas com o código pronto que esperam o serviço por trás ser liberado; ligar é pôr "true" no .env do build.
    features: {
        /// Precisa do SMTP (EmailSettings) e do App:FrontendUrl no backend.
        passwordReset: process.env.REACT_APP_PASSWORD_RESET_ENABLED === 'true',
        /// Liga quando o armazenamento definitivo (S3/RustFS, Storage:Provider no backend) estiver no ar.
        attachmentUpload: process.env.REACT_APP_ATTACHMENT_UPLOAD_ENABLED === 'true',
        /// Desligado esconde a aba e o bloco do lead; o backend e os valores gravados continuam.
        customFields: process.env.REACT_APP_CUSTOM_FIELDS_ENABLED === 'true',
    },
};
